import React, { Fragment } from 'react'
import Sidebar from '../Components/Sidebar/Sidebar'
import Headers from '../Components/Headerr/Headers'
import QRDetaail from '../Components/QRDetailScreen/QRDetaail'

function QRDetail() {
    return (
        <Fragment>
            <div class="container-fluid main">
                <div class="row">
                    <div className='col-sm-3 sideebarr'>
                        <Sidebar />
                    </div>    

                    <div className='col-sm-9 sideebarr'>
                        <Headers />
                        <QRDetaail />
                    </div>   
                </div>    
            </div>
        </Fragment>
    )
}

export default QRDetail